export default __webpack_public_path__ + "assets/circle-icon-payments-component.5e3db970.svg";